export default __webpack_public_path__ + "assets/nav-logo-white-component.f2a8a178.svg";